module.exports = __webpack_public_path__ + "img/icbc.db1fd1ec.png";